import { render, staticRenderFns } from "./manual-inputs.vue?vue&type=template&id=6efbf87a"
import script from "./manual-inputs.vue?vue&type=script&lang=js"
export * from "./manual-inputs.vue?vue&type=script&lang=js"
import style0 from "./manual-inputs.vue?vue&type=style&index=0&id=6efbf87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports